import { render } from "./VideoAccessPage.vue?vue&type=template&id=67f1d93b&scoped=true"
import script from "./VideoAccessPage.vue?vue&type=script&lang=js"
export * from "./VideoAccessPage.vue?vue&type=script&lang=js"

import "./VideoAccessPage.vue?vue&type=style&index=0&id=67f1d93b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f1d93b"]])

export default __exports__